/*
 * @ Author: wangjiyu
 * @Date: 2019-11-13 09:36:50
 * @LastEditTime: 2019-11-13 16:47:17
 * @LastEditors: wangjiyu
 * @Description: file content
 */
import { createStore, applyMiddleware } from 'redux';
import thunkMiddleware from 'redux-thunk';
import reducer from './reducer';

export default function() {
    return createStore(reducer, applyMiddleware(thunkMiddleware));
}
